﻿$.fn.dxCtrlBuilderEmailSaisieHtml = function custom_dxCtrlBuilderEmailSaisieHtml(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailsaisiehtml dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailSaisieHtml(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailSaisieHtml = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        container.css("min-height","300px")

        var jsonCssDataOriginalValue = JSON.parse(option.bodyWidget.attr("jsoncssdatawidget"))
        var stringCss = ""
        for (var prop in jsonCssDataOriginalValue) {
            stringCss += ((stringCss.length > 0) ? ";" : "") + prop + ":" + jsonCssDataOriginalValue[prop]
        }
        stringCss += ((stringCss.length > 0) ? ";" : "") + "padding:0 10px"

        var oldHtml = option.value

        if (typeof option.bddCtrl.utiCourantParaJson["editorhtmlbuilder"] == 'undefined') option.bddCtrl.utiCourantParaJson["editorhtmlbuilder"] = {}
        option.bddCtrl.utiCourantParaJson["editorhtmlbuilder"].splitter_collapsed_right = true
        option.bddCtrl.utiCourantParaJson["editorhtmlbuilder"].splitter_width_left = (container.innerWidth() - 230)
        var ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlSplitterResize2({
            bddCtrl: option.bddCtrl,
            collapsibleLeft: false,
            collapsibleRight: false,
            context_grid: "editorhtmlbuilder"
        }).dxCtrlSplitterResize2("instance")
        ctrlResize.mConstruitLeft(function (contentElementLeft) {
            ////$("<div/>").appendTo("body").dxPopup({
            ////    fullscreen: true,
            ////    contentTemplate: function (contentElement) {
            ////        dxHtmlEditor = $("<div style='width:100%;height:100%;margin:0;padding:0;border:" + theme.border + ";'/>").appendTo(contentElement).dxCtrlHtmlEditorEmail({
            ////            bddCtrl: option.bddCtrl,
            ////            html: oldHtml,
            ////            content_style: "body {" + stringCss + "}",
            ////            //toolbar: 'fontfamily fontsize forecolor bold italic underline lineheight align outdent indent bullist link emoticons code ',
            ////            onDemandeTag: function (elementEditorHtml) { mShowHideListTag(elementEditorHtml); },
            ////            //onContentReady: function (e) {
            ////            //    resizeObserver.mAdd($(container.closest(".dx-scrollview")[0]), function () {
            ////            //        e.component.element().css("height", ($(container.closest(".dx-scrollview")[0]).innerHeight() - 220) + "px")
            ////            //    })()
            ////            //    //e.component.element().css("height", "300px")
            ////            //    oldHtml = e.component.mGetContent()
            ////            //    window.setTimeout(function () { mSurveilleChange() }, 0)
            ////            //}
            ////        }).dxCtrlHtmlEditorEmail("instance")
            ////    }
            ////}).dxPopup("instance").show()

            //dxHtmlEditor = $("<div style='width:100%;height:400px;margin:0;padding:0;border:" + theme.border + ";'/>").appendTo(contentElementLeft).dxCtrlHtmlEditorEmail({
            //    bddCtrl: option.bddCtrl,
            //    html: oldHtml,
            //    content_style: "body {" + stringCss + "}",
            //    withoutAddHtmlBody:true,
            //    //toolbar: 'fontfamily fontsize forecolor bold italic underline lineheight align outdent indent bullist link emoticons code ',
            //    onDemandeTag: function (elementEditorHtml) { mShowHideListTag(elementEditorHtml); },
            //    onContentReady: function (e) {
            //        resizeObserver.mAdd($(container.closest(".dx-scrollview")[0]), function () {
            //            e.component.element().css("height", ($(container.closest(".dx-scrollview")[0]).innerHeight() - 220) + "px")
            //        })()
            //        //e.component.element().css("height", "300px")
            //        oldHtml = e.component.mGetContentSansBody()
            //        window.setTimeout(function () { mSurveilleChange() }, 0)
            //    }
            //}).dxCtrlHtmlEditorEmail("instance")


            var height = ($(container.closest(".dx-scrollview")[0]).innerHeight() - 200)
            //e.component.element().css("height", (height > 300 ? height : "300") + "px")
            dxHtmlEditor = $("<div style='width:100%;height:" + height + "px;margin:0;padding:0;border:" + theme.border + ";'/>").appendTo(contentElementLeft).dxCtrlBuilderEmailHtmlEditor({
                bddCtrl: option.bddCtrl,
                html: oldHtml,
                content_style: "body {" + stringCss + "}",
                //toolbar: 'fontfamily fontsize forecolor bold italic underline lineheight align outdent indent bullist link emoticons code ',
                onDemandeTag: function (elementEditorHtml) { mShowHideListTag(elementEditorHtml); },
                onContentReady: function (e) {
                    resizeObserver.mAdd($(container.closest(".dx-scrollview")[0]), function () {
                        var height = ($(container.closest(".dx-scrollview")[0]).innerHeight() - 200)
                        e.component.element().css("height",  height + "px")
                        //e.component.element().css("height", (height > 300 ? height : "300") + "px")
                    })()
                    //e.component.element().css("height", "300px")
                    oldHtml = e.component.mGetContent()
                    window.setTimeout(function () { mSurveilleChange() }, 0)
                }
            }).dxCtrlBuilderEmailHtmlEditor("instance")
        })

        var contentElementTagMiseEnPage = null
        var dxCtrlLstTag = null
        function mShowHideListTag(elementEditorHtml) {
            if (dxCtrlLstTag) {
                //on est sur la mise en page
                //contentElementTagMiseEnPage.remove()
                dxCtrlLstTag.element().remove()
                dxCtrlLstTag = null
                contentElementTagMiseEnPage = null
                ctrlResize.mHideRight()
            } else if (contentElementTagMiseEnPage == null) {
                //le splitter right n'est pas visible
                ctrlResize.mShowRight()
                ctrlResize.mConstruitRight(function (contentElementRight) {
                    contentElementTagMiseEnPage = contentElementRight
                    contentElementTagMiseEnPage.css({
                        "position": "relative",
                        "background-color": theme.backgroundcolorTooltip
                    })
                    mShow()
                })
            } else {
                //le splitter right est visible avec les tag dedans
                dxCtrlMiseEnPage.element().fadeOut(300, function () {
                    dxCtrlMiseEnPage.element().remove();
                    dxCtrlMiseEnPage = null;
                })
                mShow()
            }

            function mShow() {
                dxCtrlLstTag = $("<div style='width:100%;height:100%;position:absolute;display:none;border-top:" + theme.border + ";border-bottom:" + theme.border + ";border-right:" + theme.border + ";'/>").appendTo(contentElementTagMiseEnPage).dxCtrlEmailLstTag({
                    bddCtrl: option.bddCtrl,
                    lstLibelleAdded: ["LIEN EMAILING"],
                    elementEditorHtml: elementEditorHtml,
                    allowChampForDestinataire: option.allowChampForDestinataireForTag,
                    onClose: function () { mShowHideListTag(elementEditorHtml); }
                }).dxCtrlEmailLstTag("instance")
                dxCtrlLstTag.element().fadeIn(300)
            }
        }



        function mSurveilleChange() {
            if (container.closest("body").length == 0) return
            //option.value = dxHtmlEditor.mGetContentSansBody()
            option.value = dxHtmlEditor.mGetContent()
            if (oldHtml != option.value) {
                oldHtml = option.value
                option.onValueChanged(option.value)
            }
            if (container.closest("body").length > 0) window.setTimeout(function () { mSurveilleChange() }, 1000)
        }
    }

    this.getCurrentEditorHtml = function () { return dxHtmlEditor.getCurrentEditorHtml() }

    this.element = function () { return container }

    mConstruit();
}